import { useCreateGroupMutation, useGetAllGroups } from '~entities/groups';

import Creatable from '~shared/components/select/creatable';
import { capitalizeWords } from '~shared/helpers/text-formatting';

export interface GroupsOption {
  label: string;
  value: string;
}

export interface GroupsSelectorProps {
  value: Array<GroupsOption>;
  onChange: (value: Array<GroupsOption> | undefined | null) => void;
}
export const GroupsSelector = ({ value, onChange }: GroupsSelectorProps) => {
  const { data, isFetching } = useGetAllGroups();
  const mutation = useCreateGroupMutation();
  const options = data?.map((group) => ({
    label: capitalizeWords(group.fieldName),
    value: group._id,
  }));

  return (
    <Creatable
      value={value}
      onChange={(option) => {
        const opt = option as Array<GroupsOption> | null | undefined;
        onChange(opt);
      }}
      onCreateOption={async (inputValue: string) => {
        const group = await mutation.mutateAsync({ fieldName: inputValue });
        onChange([
          ...value,
          { label: capitalizeWords(group.fieldName), value: group._id },
        ]);
      }}
      isMulti
      placeholder='Select Groups'
      options={options}
      isLoading={isFetching}
    />
  );
};
